<template>
  <div>
    <el-form ref="ruleForm" label-width="140px" class="demo-ruleForm">
      <el-form-item label="IOS屏蔽">
        <el-button size="mini" type="primary" @click="setIosShield('on')" :loading="loading">开启
        </el-button>
        <el-button size="mini" type="warning" @click="setIosShield('off')" :loading="loading">关闭
        </el-button>
      </el-form-item>

      <el-form-item label="微信小店解密重置">
        <el-date-picker v-model="info.start_time" value-format="yyyy-MM-dd" type="date"
          placeholder="选择时间"></el-date-picker>
        <el-button size="mini" type="primary" @click="decryptOperate()" :loading="decrypt_loading"
          style="margin-left: 15px;">确定
        </el-button>
      </el-form-item>

      <el-form-item label="HTML文件">
        <el-upload ref="upload" action="/backend/manage/system/uploadHtmlQAMX4WGM" :data="form"
          :before-upload="beforeUpload" :on-success="onSuccess" :on-error="onError" :limit="1" accept=".html,.htm" drag>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将 HTML 文件拖到此处，或<em>点击上传</em>
          </div>
          <div slot="tip" class="el-upload__tip">
            只能上传 .html 文件，且不超过 5MB。
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { setIosShield, decryptOperate } from "@/api/manage/system/system";

export default {
  data: function () {
    return {
      loading: false,
      decrypt_loading: false,
      info: {
        start_time: "",
      },
    };
  },

  methods: {
    beforeUpload (file) {
      const isHTML = file.name.endsWith('.html') || file.name.endsWith('.htm')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isHTML) {
        this.$message.error('只能上传 HTML 文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过 5MB')
        return false
      }
      return true
    },
    onSuccess (res) {
      if (res.status != 2000) {
        this.$message.error('上传失败：' + res.message);
        this.$refs.upload.clearFiles();
        return
      } else {
        // this.$message({
        //   showClose: true,
        //   message: '上传成功：' + res.data.url,
        //   type: 'success',
        //   duration: 0
        // });
        this.$alert(res.data.url, '上传成功', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            });
          }
        });
        this.$refs.upload.clearFiles();
      }
    },
    onError (err) {
      this.$message.error('上传失败：' + (err.message || '未知错误'))
    },

    setIosShield (action) {
      this.$prompt("请输入版本号", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^([1-9]\d|[1-9])(\.([0-9]){1,2}){2}$/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          this.loading = true;
          setIosShield({
            action: action,
            version: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
          this.loading = false;
        })
        .catch(() => { });
    },


    decryptOperate () {
      if (this.info.start_time == '') {
        this.$message({
          message: '重置时间不能为空',
          type: "error",
        });
        return false
      }
      this.is_delete = 1
      this.$confirm("是否将微信小店解密重置？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        decryptOperate({
          created_at: this.info.start_time
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: response.message,
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
  },
};
</script>

<style></style>
